import React from 'react';
import './WhatIsDoggy.css';

// Founders
import adrianPhoto from '../../assets/logos/adrian2.jpeg';
import israPhoto from '../../assets/logos/isra.jpg';

// Historia images
import primerStream from '../../assets/logos/primer_stream.webp';
import streamsImg from '../../assets/logos/streams.webp';
import meme01 from '../../assets/logos/meme01.webp';
import meme03 from '../../assets/logos/meme03.webp';
import doggyjate from '../../assets/logos/doggyjate.jpeg';

/**
 * SECCIÓN 3: ¿QUÉ ES $DOGGY?
 * Historia + Founders + Posicionamiento Latam
 */

const founders = [
  {
    name: 'Adrián',
    handle: '@adriansanpei',
    photo: adrianPhoto,
    bio: 'Bitcoiner desde 2017\nHizo 100x en su portafolio\nCreador de contenido cripto y cofundador de El Holder',
    social: 'twitter',
    socialUrl: 'https://x.com/adriansanpei',
    socialLabel: '@adriansanpei',
  },
  {
    name: 'Isra',
    handle: '@isracryptoeth',
    photo: israPhoto,
    bio: 'Cripto bro desde 2017\nCreador de contenido para inversiones\ncon +200k followers',
    social: 'instagram',
    socialUrl: 'https://www.instagram.com/isracrypto.eth/',
    socialLabel: '@isracrypto.eth',
  },
];

const WhatIsDoggy = () => {

  return (
    <section className="what-is section section--alt" id="que-es">
      <div className="container">
        
        {/* Headline */}
        <h2 className="what-is__title">¿Qué es <span>$Doggy</span>?</h2>
        <p className="what-is__intro">
          La Moneda de México
        </p>
        <p className="what-is__intro-sub">Creada por</p>

        {/* Founders — right after "Creada por" */}
        <div className="what-is__founders">
          {founders.map((founder, index) => (
            <div key={index} className="what-is__founder-card">
              <div className="what-is__founder-photo">
                <img src={founder.photo} alt={founder.name} loading="lazy" />
              </div>
              <div className="what-is__founder-info">
                <h4 className="what-is__founder-name">{founder.name}</h4>
                <p className="what-is__founder-bio">
                  {founder.bio.split('\n').map((line, i) => (
                    <span key={i}>{line}<br/></span>
                  ))}
                </p>
                <a 
                  className={`what-is__founder-social what-is__founder-social--${founder.social}`}
                  href={founder.socialUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {founder.social === 'twitter' ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                    </svg>
                  )}
                  Sígueme en {founder.socialLabel}
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Historia — Visual Feed */}
        <h3 className="what-is__story-heading">Nuestra historia</h3>
        
        <div className="what-is__story">
          {/* Momento 1: El inicio */}
          <div className="what-is__story-block">
            <p className="what-is__story-caption">15 de septiembre 2025</p>
            <div className="what-is__story-img">
              <img src={primerStream} alt="Primer stream de DOGGY" loading="lazy" />
            </div>
            <p className="what-is__story-desc">Dos mexas y un sueño, nos subimos a celebrar el grito de independencia en vivo, esperando que los gringos compraran nuestra moneda</p>
          </div>

          <div className="what-is__story-arrow">↓</div>

          {/* Momento 2: $20k */}
          <div className="what-is__story-block">
            <p className="what-is__story-caption what-is__story-caption--gold">Ese mismo día...</p>
            <div className="what-is__story-img">
              <img src={streamsImg} alt="Streams diarios de DOGGY" loading="lazy" />
            </div>
            <p className="what-is__story-desc">Sube a <strong>$20,000 USD</strong> y empezamos a streamear diario</p>
          </div>

          <div className="what-is__story-arrow">↓</div>

          {/* Momento 3: Memes virales */}
          <div className="what-is__story-block">
            <p className="what-is__story-caption">La comunidad se prende 🔥</p>
            <p className="what-is__story-desc">Comunidad empieza a viralizar memes en Twitter</p>
            <div className="what-is__story-memes">
              <img src={meme01} alt="Meme DOGGY" loading="lazy" />
              <img src={meme03} alt="Meme DOGGY" loading="lazy" />
              <img src={doggyjate} alt="Meme DOGGY" loading="lazy" />
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default WhatIsDoggy;
